const ErrorService = {
    log(error: any) {
        if (import.meta.env.DEV) {
            console.error('[ErrorService]', error);
        }

        // Send to Slack
        // fetch('/api/log', { method: 'POST', body: JSON.stringify(error) });
    },
};

export default ErrorService;
